export const env = {
	appName: "Tabulerasa",
	apiBaseUrl: "https://hellephant.herokuapp.com/api/v1"
}